<div class="calendar-filter mt-3 mb-3">
  @if (loading) {
    <div class="overlay">
      <div class="spinner">
        <nz-spin [nzSize]="'small'" nzSimple="true"></nz-spin>
      </div>
    </div>
  } @else {
    @if (months) {
      <ul>
        @for (monthItem of months; track monthItem) {
          <li class="calendar-month-item float-lg-end">
            <span
              nz-popover
              [ngClass]="getCssClass(monthItem, 'M')"
              [ngStyle]="getCssStyle(monthItem)"
              (click)="onSelectMonth(monthItem)"
              [nzPopoverContent]="showTooltip && hasTooltipData(monthItem) ? monthTooltipTemplate : null">
              {{ monthItem.label }}
            </span>
            <ng-template #monthTooltipTemplate>
              <app-calendar-tooltip-table [data]="monthItem.extra"></app-calendar-tooltip-table>
            </ng-template>
          </li>
        }
      </ul>
    }

    @if (month && days) {
      <ul>
        @for (dayItem of days; track dayItem) {
          <li class="calendar-day-item size-{{ this.noOfDays }}">
            <span
              nz-popover
              [ngClass]="getCssClass(dayItem, 'D')"
              [ngStyle]="getCssStyle(dayItem)"
              (click)="onSelectDay(dayItem)"
              [nzPopoverContent]="showTooltip && hasTooltipData(dayItem) ? dayTooltipTemplate : null">
              {{ dayItem.label }}
            </span>
            <ng-template #dayTooltipTemplate>
              <app-calendar-tooltip-table [data]="dayItem.extra"></app-calendar-tooltip-table>
            </ng-template>
          </li>
        }
      </ul>
    }

    @if (day && hours) {
      <ul>
        @for (hourItem of hours; track hourItem) {
          <li class="calendar-hour-item">
            <span
              nz-popover
              [ngClass]="getCssClass(hourItem, 'H')"
              [ngStyle]="getCssStyle(hourItem)"
              (click)="onSelectHour(hourItem)"
              [nzPopoverContent]="showTooltip && hasTooltipData(hourItem) ? hourTooltipTemplate : null">
              {{ hourItem.label }}
            </span>
            <ng-template #hourTooltipTemplate>
              <app-calendar-tooltip-table [data]="hourItem.extra"></app-calendar-tooltip-table>
            </ng-template>
          </li>
        }
      </ul>
    }
  }
</div>
